import { Chip, Theme } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledChip = styled(Chip)(({ theme }: { theme: Theme }) => ({
  height: "24px",
  borderRadius: "6px",
  "& .MuiChip-deleteIcon": {
    width: "12px",
  },
  "& .MuiChip-label": {
    lineHeight: 1,
  },
}));
